import React from 'react';
import { Dialog, DialogContent, DialogTitle, Typography, IconButton, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const Relatorio = ({ open, handleClose, processo }) => {

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('pt-BR', options);
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle style={{ backgroundColor: '#f5f5f5', padding: '10px 20px' }}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Typography variant="h5" style={{ fontWeight: 'bold' }}>Relatório do Processo</Typography>
                    <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Paper elevation={3} style={{ padding: '16px', marginBottom: '20px' }}>
                            <Typography variant="h6" style={{ marginBottom: '10px', color: '#3f51b5' }}>Informações Gerais</Typography>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell><strong>Nome do Processo:</strong></TableCell>
                                            <TableCell>{processo.processo}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Descrição:</strong></TableCell>
                                            <TableCell>{processo.descricao}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Atividade:</strong></TableCell>
                                            <TableCell>{processo.atividade}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Finalidade:</strong></TableCell>
                                            <TableCell>{processo.finalidade}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Áreas Selecionadas:</strong></TableCell>
                                            <TableCell>{processo.areas_selecionadas_nome}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Áreas com Acesso:</strong></TableCell>
                                            <TableCell>{processo.areas_com_acesso_nome}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Responsável:</strong></TableCell>
                                            <TableCell>{processo.responsavel_nome}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>RIPD:</strong></TableCell>
                                            <TableCell>{processo.ripd}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Riscos:</strong></TableCell>
                                            <TableCell>{processo.riscos}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Classificação de Riscos:</strong></TableCell>
                                            <TableCell>{processo.classificacao_riscos}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Dados Armazenados:</strong></TableCell>
                                            <TableCell>{processo.armazenados}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Descrição dos Dados Armazenados:</strong></TableCell>
                                            <TableCell>{processo.armazenados_texto}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Armazenamento:</strong></TableCell>
                                            <TableCell>{processo.armazenamento}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Data da Entrevista:</strong></TableCell>
                                            <TableCell>{formatDate(processo.created_at)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper elevation={3} style={{ padding: '16px', marginBottom: '20px' }}>
                            <Typography variant="h6" style={{ marginBottom: '10px', color: '#3f51b5' }}>Outras Informações</Typography>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell><strong>Dados Pessoais Tratados:</strong></TableCell>
                                            <TableCell>{processo.dados_pessoais_tratados.join(', ')}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Dados Sensíveis:</strong></TableCell>
                                            <TableCell>{processo.dados_sensiveis ? 'Sim' : 'Não'}</TableCell>
                                        </TableRow>
                                        {processo.desc_sensiveis &&
                                            <TableRow>
                                                <TableCell><strong>Descrição dos Dados Sensíveis:</strong></TableCell>
                                                <TableCell>{processo.desc_sensiveis.join(', ')}</TableCell>
                                            </TableRow>
                                        }
                                        <TableRow>
                                            <TableCell><strong>Dados de Menores:</strong></TableCell>
                                            <TableCell>{processo.dados_menor ? 'Sim' : 'Não'}</TableCell>
                                        </TableRow>
                                        {processo.desc_dados_menor &&
                                            <TableRow>
                                                <TableCell><strong>Descrição dos Dados de Menores:</strong></TableCell>
                                                <TableCell>{processo.desc_dados_menor.join(', ')}</TableCell>
                                            </TableRow>
                                        }
                                        <TableRow>
                                            <TableCell><strong>Dados Sensíveis de Menores:</strong></TableCell>
                                            <TableCell>{processo.dados_menor_sensiveis ? 'Sim' : 'Não'}</TableCell>
                                        </TableRow>
                                        {processo.desc_dados_menor_sensiveis &&
                                            <TableRow>
                                                <TableCell><strong>Descrição dos Dados Sensíveis de Menores:</strong></TableCell>
                                                <TableCell>{processo.desc_dados_menor_sensiveis.join(', ')}</TableCell>
                                            </TableRow>
                                        }
                                        <TableRow>
                                            <TableCell><strong>Compartilhamento Externo:</strong></TableCell>
                                            <TableCell>{processo.compartilhamento_externo ? 'Sim' : 'Não'}</TableCell>
                                        </TableRow>
                                        {processo.compartilhamento_externo_terceirizados &&
                                            <TableRow>
                                                <TableCell><strong>Terceirizados:</strong></TableCell>
                                                <TableCell>{processo.compartilhamento_externo_terceirizados}</TableCell>
                                            </TableRow>
                                        }
                                        <TableRow>
                                            <TableCell><strong>Transferência Internacional:</strong></TableCell>
                                            <TableCell>{processo.transferencia_internacional ? 'Sim' : 'Não'}</TableCell>
                                        </TableRow>
                                        {processo.transferencia_internacional_text &&
                                            <TableRow>
                                                <TableCell><strong>Detalhes da Transferência Internacional:</strong></TableCell>
                                                <TableCell>{processo.transferencia_internacional_text}</TableCell>
                                            </TableRow>
                                        }
                                        <TableRow>
                                            <TableCell><strong>Ações:</strong></TableCell>
                                            <TableCell>{processo.acoes}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><strong>Base Legal:</strong></TableCell>
                                            <TableCell>{processo.bases.join(', ')}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default Relatorio;
